import { default as MuiTableRow } from '@mui/material/TableRow';

/**
 * TableRow represents a single row within a Table.
 *
 * Demos:
 *
 * - [Table](https://unify.workiva.org/components/table?tab=code)
 *
 * API:
 *
 * - [TableRow API](https://unify.workiva.org/components/table?tab=props#tablerow)
 */
export const TableRow = MuiTableRow;
export { type TableRowProps, tableRowClasses } from '@mui/material/TableRow';
